export default "__VITE_ASSET__KQHxRKgj__"